export const confiugredIssueTypes = [
	{
		name: 'Task',
		avatarId: 10318,
	},
];

export const ANALYTIC_EVENT_ACTION_SUCCEEDED = 'succeeded';
export const ANALYTIC_EVENT_ACTION_STARTED = 'started';
export const ANALYTIC_EVENT_ACTION_FAILED = 'failed';

export const PROJECT_CREATE_ANALYTIC_EVENT_NAME = 'project creation';
export const PROJECT_POLLING_ANALYTIC_EVENT_NAME = 'project polling';
export const MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME = 'madlib content generation';

export const MADLIB_FLOW = 'madlib';
export const DEFAULT_FLOW = 'default';

/** Screen indices for the madlib Setup flow (space-details → madlib → invite → loading). */
export const SETUP_SCREEN_INDEX_SPACE_DETAILS = 0;
export const SETUP_SCREEN_INDEX_MADLIB = 1;
export const SETUP_SCREEN_INDEX_INVITE = 2;
export const SETUP_SCREEN_INDEX_LOADING = 3;

/** Screen index for invite in the FFL Setup flow (space-details → invite → loading). */
export const SETUP_SCREEN_INDEX_FFL_INVITE = 1;
